// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "5597f6a-dirty",
    "hash": "5597f6a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5597f6a-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
